module.exports = __webpack_public_path__ + "img/processbar.f96d1947.svg";